import { m } from 'framer-motion'
import { alpha } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { useRouter } from 'src/routes/hooks'
import { varHover } from 'src/components/animate'
import CustomPopover, { usePopover } from 'src/components/custom-popover'
import React from 'react'
import { useLogout } from 'react-admin'

export default function AccountPopover() {
    const router = useRouter()
    const popover = usePopover()
    const logout = useLogout()

    const handleLogout = async () => {
        try {
            await logout()
            popover.onClose()
            router.replace('/')
        } catch (error) {
            console.error(error)
        }
    }

    const name = localStorage.getItem('prosha.user.name') ?? 'X'

    return (
        <>
            <IconButton
                component={m.button}
                whileTap="tap"
                whileHover="hover"
                variants={varHover(1.05)}
                onClick={popover.onOpen}
                sx={{
                    width: 40,
                    height: 40,
                    background: (theme) => alpha(theme.palette.grey[500], 0.08),
                    ...(popover.open && {
                        background: (theme) =>
                            `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
                    }),
                }}
            >
                <Avatar
                    src={name}
                    alt={name}
                    sx={{
                        width: 36,
                        height: 36,
                        border: (theme) => `solid 2px ${theme.palette.background.default}`,
                    }}
                >
                    {name.charAt(0).toUpperCase()}
                </Avatar>
            </IconButton>

            <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
                <Box sx={{ p: 2, pb: 1.5 }}>
                    <Typography variant="subtitle2" noWrap>
                        {name}
                    </Typography>
                </Box>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <MenuItem
                    onClick={async () => {
                        await handleLogout()
                    }}
                    sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
                >
                    Logout
                </MenuItem>
            </CustomPopover>
        </>
    )
}
